import { render, staticRenderFns } from "./CampaignSendablePreview.vue?vue&type=template&id=1ef65c14"
import script from "./CampaignSendablePreview.vue?vue&type=script&lang=js"
export * from "./CampaignSendablePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports